import { formatInteger, formatPercent } from "../../../i18n/format";
import { useInterfaceLocale } from "./useInterfaceLocale";

/** A grouped whole number in the Interface Language: 21338 -> 21,338 / 21.338. */
export function Num({ value }: { value: number | null | undefined }) {
  const locale = useInterfaceLocale();
  return (
    <span data-component="Num" className="tabular-nums">
      {formatInteger(value, locale)}
    </span>
  );
}

/** A fraction 0..1 as a percentage: 0.64 -> "64 %" / "64%". */
export function Percent({ value }: { value: number | null | undefined }) {
  const locale = useInterfaceLocale();
  return (
    <span data-component="Percent" className="tabular-nums">
      {formatPercent(value, locale)}
    </span>
  );
}
